module.exports = __webpack_public_path__ + "static/img/FuXiang_jianjiePic.58fe53a3.png";